// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen` from
// x-flags.doRenderReactQueryQueryHook on POST /session/list.

import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import type {
  typeSessionListBody,
  typeSessionListOutput200,
} from "../../sdk/session/postSessionList";
import useCallSdk from "../../sdk-helpers/useCallSdk";

export function buildSessionListQueryKey(
  payload: typeSessionListBody,
): string[] {
  const queryKeySegments: string[] = [];

  return ["post:session:sessionList", "svc:auth-api", ...queryKeySegments];
}

type QueryOptions = Partial<
  UseQueryOptions<
    typeSessionListOutput200,
    unknown,
    typeSessionListOutput200,
    string[]
  >
> & {
  // Isolates two callers that query the same data for independent UI state
  // (e.g. a dropdown search vs a table both listing the same resource).
  queryKeyIdentifier?: string;
};

export default function useSessionList(
  payload: typeSessionListBody,
  options?: QueryOptions,
) {
  // No staleTime default here on purpose. Freshness is the consuming app's
  // decision and belongs in its QueryClient, in one place: a default set on the
  // hook would silently beat it for every screen. Pass one per call to override.
  const resolvedOptions = options ?? {};

  let queryKey = buildSessionListQueryKey(payload);
  if (resolvedOptions.queryKeyIdentifier) {
    queryKey = [...queryKey, resolvedOptions.queryKeyIdentifier];
  }

  const { callSdk } = useCallSdk();
  return useQuery({
    queryKey,
    queryFn: () => callSdk().postSessionList(payload),
    ...resolvedOptions,
  });
}
